import { render, staticRenderFns } from "./resetPw_vn.vue?vue&type=template&id=67c35112&scoped=true&"
import script from "./resetPw_vn.vue?vue&type=script&lang=js&"
export * from "./resetPw_vn.vue?vue&type=script&lang=js&"
import style0 from "./resetPw_vn.vue?vue&type=style&index=0&id=67c35112&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c35112",
  null
  
)

export default component.exports